import validate from "/builds/pro/webshop/frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
import custom_45router_45global from "/builds/pro/webshop/frontend/node_modules/@xsarus-npm/nuxt-base/src/nuxt-base/app/middleware/customRouter.global.ts";
import manifest_45route_45rule from "/builds/pro/webshop/frontend/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  custom_45router_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}